export enum EntityStates {
  Erledigt = 'Erledigt',
  Archiviert = 'Archiviert',
  Abgeschlossen = 'Abgeschlossen',
  // Incidents
  Bereitgestellte_Informationen = 'Bereitgestellte Informationen',

  Storniert = 'Storniert',
}
